import { IKnmActExpertSelectOption } from 'CorePackage/CatalogsModule/interfaces/IKnmActExpertSelectOption';
import { makeRequired } from 'CorePackage/MainModule/validators/isRequired';

export const getEventExpertsValidate = (
  experts: IKnmActExpertSelectOption[] | undefined,
): (string | undefined)[] | string[] | undefined => {
  if (!experts?.length) {
    return undefined;
  }

  return experts.map(expert => makeRequired('Поле не может быть пустым')(expert?.id ? expert : undefined));
};
